<template>
  <div>
    <div class="flex flex-wrap flex_gap_5 coords mb-1">
      <div class="input-group" v-for="(c, i) in area.coords">
        <div class="input-group-prepend">
          <input @change="toUpdate" v-model="area.coords[i][0]" type="text" class="form-control"/>
        </div>
        <input type="text" @change="toUpdate" v-model="area.coords[i][1]" class="form-control">
      </div>
      <button type="button" @click="addPoint" class="btn btn-default"><i class="icon-fa icon-fa-plus"/></button>
    </div>
    <div class="flex">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text small">Цвет фона</span>
        </div>
        <input type="text" @change="toUpdate" v-model="area.fillColor"
               class="form-control">
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text small">Цвет контура</span>
        </div>
        <input type="text" @change="toUpdate" v-model="area.strokeColor"
               class="form-control">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['area', 'toUpdate'],
  methods: {
    addPoint() {
      this.area.coords.push([0, 0]);
    }
  }
}

</script>

<style scoped>
input.form-control {
  width: fit-content;
  min-width: 1%;
}

.input-group {
  flex-wrap: nowrap;
  width: auto;
}

.input-group input {
  max-width: 110px;
}
</style>
